import { Component } from '@angular/core';
import { IaChatService } from '../service/ia-chat.service';

@Component({
    selector: 'app-chatbot',
    templateUrl: './chatbot.component.html',
    styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent {

    visible: boolean = false;
    userInput: string = '';
    messages: { text: string, sender: 'user' | 'ai' }[] = [];
    isLoading: boolean = false;

    constructor(private iaChatService: IaChatService) { }

    toggleChat() {
        this.visible = !this.visible;
    }

    sendMessage() {
        if (!this.userInput.trim()) return;

        const structureId = sessionStorage.getItem('courrante');
        if (!structureId) {
            this.messages.push({
                text: "Selectionnez une entreprise pour utiliser l'assistant IA.",
                sender: 'ai'
            });
            this.scrollBottom();
            return;
        }

        const message = this.userInput;
        this.messages.push({ text: message, sender: 'user' });
        this.userInput = '';
        this.isLoading = true;

        this.scrollBottom();

        this.iaChatService.ask(message, structureId).subscribe({
            next: (res) => {
                this.messages.push({ text: res.response, sender: 'ai' });
                this.isLoading = false;
                this.scrollBottom();
            },
            error: (err) => {
                console.error('Chat error', err);
                const backendMessage = err?.error?.response;
                this.messages.push({
                    text: backendMessage || "Désolé, une erreur est survenue. Veuillez réessayer.",
                    sender: 'ai'
                });
                this.isLoading = false;
                this.scrollBottom();
            }
        });
    }

    scrollBottom() {
        setTimeout(() => {
            const chatContainer = document.querySelector('.chat-history');
            if (chatContainer) {
                chatContainer.scrollTop = chatContainer.scrollHeight;
            }
        }, 100);
    }
}
